import React from 'react';
import { Row, Col, Image, ToolTip } from '../../../importCL';
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';


const Approved = ({
    selectedCard,
    applicationCode,
    smCreditLine,
    creditLine,
}) => {
    return (
        <div>
            <Row>
                <Col
                    className='ConfirmationPageHero__card'
                    lg={12}
                    md={12}
                    
                >
                    <Image
                        className='ConfirmationPageHero__cardImage'
                        loading='lazy'
                        src={selectedCard.path ?? ''}
                        alt={selectedCard.altText}
                    />
                    {!selectedCard.tooltipText ? (
                        ''
                    ) : (
                        <ToolTip
                            className='ConfirmationPageHero__toolTip'
                            mobileNotchPosition='top-right'
                        >
                            <div>{transformHTMLParserLinks(wrapTrademarkSuperscript(selectedCard.tooltipText))}</div>
                        </ToolTip>
                    )}
                </Col>
            </Row>
            <Row>
                <Col
                    id='applicationCode'
                    className='ConfirmationPageHero__applicationCode'
                    lg={12}
                    md={12}
                >
                    Application Code: <strong> {applicationCode} </strong>
                </Col>
            </Row>
            {selectedCard.isPremium ? (
                <Row>
                    <Col
                        className='ConfirmationPageHero__cardDesign'
                        lg={12}
                        md={12}
                    >
                        {selectedCard.fee > 0 && (
                            <>
                                Card Design:{' '}
                                <strong>
                                    {selectedCard.name} (${selectedCard.fee})
                                </strong>
                            </>
                        )}
                    </Col>
                </Row>
            ) : (
                ''
            )}

            {smCreditLine ? (
                <Row>
                    <Col
                        className='ConfirmationPageHero__creditLine'
                        lg={12}
                        md={12}
                    >
                        Credit Line: ${creditLine.toLocaleString()}
                    </Col>
                </Row>
            ) : (
                ''
            )}
        </div>
    );
};

export default Approved;